import { render } from "./InBoarding.vue?vue&type=template&id=3e70e8ef&scoped=true"
import script from "./InBoarding.vue?vue&type=script&lang=js"
export * from "./InBoarding.vue?vue&type=script&lang=js"

import "./InBoarding.vue?vue&type=style&index=0&id=3e70e8ef&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e70e8ef"]])

export default __exports__